export const getMetaTag = (key: string, attribute = 'name', property = 'content') => {
    const metaTag = document.querySelector(`meta[${attribute}="${key}"]`);
    if (metaTag) {
        // @ts-ignore
        return metaTag[property];
    } else {
        return null;
    }
}
